import { useDocuments } from '@/hooks/use-documents'
import { useMyJobMatches } from '@/hooks/use-external-jobs'

export function useNavVisibility() {
  const { data: documents } = useDocuments()
  const { data: jobMatches } = useMyJobMatches(0, 1)

  const resumes = documents?.filter((d) => d.document_type === 'resume') || []
  const resumeCount = resumes.length
  const hasResume = resumes.some((d) => d.status === 'ready')
  const hasJobMatches = (jobMatches?.total ?? 0) > 0

  return { hasResume, hasJobMatches, resumeCount, resumes, documents }
}
